import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'input-box',
	templateUrl: './input-box.component.html',
	styleUrls: ['./input-box.component.scss']
})
export class InputBoxComponent implements OnInit {
	@Input() public inputPlaceholder: string = '';
	@Input() public color: string = '';
	@Input() public icon: string = '';
	@Output() public inputChange: EventEmitter<string> = new EventEmitter<string>();

	public inputValue: string = '';

	public ngOnInit(): void {
		this.inputChange.emit(this.inputValue);
	}
	public onInputChange(newInput: string): void {
		this.inputChange.emit(newInput);
	}
}
